import { getETLRunQueryOptions } from "../../queries/ETLRuns";

// ETLRun is pre-fetched when a user hover a 'view ETLRun' link
export const ETLRunViewLoader = ({ params, context: { queryClient } }) => {
  const { ETLRunId } = params;
  queryClient.ensureQueryData(getETLRunQueryOptions(ETLRunId, queryClient));
};
